import React from 'react';
// 버튼 정보 입력 관련 comp
class ButtonInfoCompClass extends React.Component{
    constructor(props) {
        super(props);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.state={}
    }// end constructor

    async handleSelect(e) {
        const { SelfAction, index, buttonIndex, button, isRemind } = this.props;

        if(isRemind) return;

        const type = e.target.value;
        let val1 = type === '0' ? 'https://' : '';
        let val2 = type === '2' ? 'https://' : '';

        const updatedButton = { ...button, type: type, val1: val1, val2: val2 };
        await SelfAction.updateButton(updatedButton, buttonIndex, index);
    }
    async handleInputChange(e) {
        const { SelfAction, index, buttonIndex, button, isRemind } = this.props;
        if(isRemind) return;

        let value = e.target.value;
        if(e.target.name === 'name') {
            if (value.length > 17) {
                alert("버튼 이름은 17자까지만 가능합니다!");
                value = value.slice(0, 17);
            }
        }
        const updatedButton = { ...button, [e.target.name]: value };
        await SelfAction.updateButton(updatedButton, buttonIndex, index);
    }

    render() {

        const { buttonIndex, button, isRemind } = this.props;
        const { handleSelect, handleInputChange } = this;

        return (
            <tr>
                <td>{buttonIndex + 1}</td>
                <td className='v-align-top'>
                    <select className='form-select' onChange={handleSelect} name="buttonType" disabled={isRemind}>
                        <option value="0" defaultChecked={true}>웹링크</option>
                        <option value="1">전화 걸기</option>
                        <option value="2">지도 보여주기</option>
                    </select>
                </td>
                <td className='v-align-top'>
                    <input
                        className='form-control'
                        type="text"
                        name={"name"}
                        placeholder="버튼 명"
                        onChange={handleInputChange}
                        value={button?.name ?? ''}
                        disabled={isRemind}
                    />
                </td>
                <td className='v-align-top'>
                    {button.type === "0" &&
                        <input
                            className='form-control'
                            type="text"
                            name={"val1"}
                            placeholder="URL 주소 입력"
                            onChange={handleInputChange}
                            value={button?.val1 ?? ''}
                            disabled={isRemind}
                        />}
                    {button.type === "1" &&
                        <input
                            className='form-control'
                            type="tel"
                            name={"val1"}
                            placeholder="전화번호 입력"
                            onChange={handleInputChange}
                            value={button?.val1 ?? ''}
                            disabled={isRemind}
                        />}
                    {button.type === "2" &&
                        (<>
                            <input
                                className='form-control'
                                type="text"
                                name={"val1"}
                                onChange={handleInputChange}
                                placeholder="위치 이름을 입력"
                                value={button?.val1 ?? ''}
                                disabled={isRemind}
                                /> <br/>
                            <input
                                className='form-control'
                                type="text"
                                name={"val2"}
                                onChange={handleInputChange}
                                placeholder="검색 URL 입력"
                                value={button?.val2 ?? ''}
                                disabled={isRemind}
                            />
                        </>)
                    }
                </td>
            </tr>
        )
    }// end render
}// end class

export default ButtonInfoCompClass;
